import clsx from 'clsx';
import { PanelRightClose, PanelRightOpen } from 'lucide-react';

import { DmPane } from '../dms';
import { useShell } from './state';
import styles from './shell.module.css';

/**
 * DM sidebar — collapsible right pane. Collapsed by default when the world
 * view is mounted (CLIENT_DESIGN §13.1); the collapse toggle lives in the
 * header handle. D10 populates the body with conversations.
 */
export function DmSidebar(): JSX.Element {
  const collapsed = useShell((s) => s.dmSidebarCollapsed);
  const toggle = useShell((s) => s.toggleDmSidebar);

  return (
    <aside
      className={clsx(
        styles.dmSidebar,
        collapsed && styles.dmSidebarCollapsed,
      )}
      aria-label="Direct messages"
      aria-expanded={!collapsed}
    >
      <button
        type="button"
        className={styles.dmSidebarHandle}
        onClick={toggle}
        aria-label={collapsed ? 'Expand DM sidebar' : 'Collapse DM sidebar'}
      >
        {collapsed ? (
          <PanelRightOpen size={18} />
        ) : (
          <PanelRightClose size={18} />
        )}
      </button>

      {!collapsed ? (
        <div className={styles.dmSidebarBody}>
          <DmPane />
        </div>
      ) : null}
    </aside>
  );
}
